import React from 'react';
import { Modal } from 'Components/frameworks/modal/Modal';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { t } from 'Src/i18n';
import { DayPriceDoubleSeasonPopin } from './DayPriceDoubleSeasonPopin';
export const DayPriceDoubleSeason = ({
  availability,
  product,
  isMouseOverDoubleSeasonPopin,
  isVisible,
  setInvisible,
  setIsMouseOverDoubleSeasonPopin,
  statusMessageKey,
}: {
  availability: string;
  product: Product;
  isMouseOverDoubleSeasonPopin: boolean;
  isVisible: boolean;
  setInvisible: () => void;
  setIsMouseOverDoubleSeasonPopin: (arg0: boolean) => void;
  statusMessageKey: string;
}) => {
  const { isTablet } = useResponsive();

  const stopEventBubbling = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const closeModal = (e) => {
    stopEventBubbling(e);
    setInvisible();
  };

  const trackingData = {
    actionGA: 'calendarPrice',
  };
  return (
    (isVisible || isMouseOverDoubleSeasonPopin) && (
      <div onClick={stopEventBubbling}>
        {isTablet ? (
          <aside className="arrow arrow-bg-lightGrey arrow-down arrow-white animation-duration-500 absolute bottom-full left-1/2 z-3 w-280 -translate-x-1/2 transform animate-fadeIn font-normal shadow-diffuse">
            <div className="text-initial overflow-hidden rounded-12 border border-lightGrey bg-white">
              <DayPriceDoubleSeasonPopin
                availability={availability}
                product={product}
                setInvisible={setInvisible}
                setIsMouseOverDoubleSeasonPopin={setIsMouseOverDoubleSeasonPopin}
                statusMessageKey={statusMessageKey}
                trackingData={trackingData}
              />
            </div>
          </aside>
        ) : (
          <Modal closeLabel={t('common.close')} onClose={closeModal} size="small">
            <DayPriceDoubleSeasonPopin
              availability={availability}
              product={product}
              statusMessageKey={statusMessageKey}
              trackingData={trackingData}
            />
          </Modal>
        )}
      </div>
    )
  );
};
